import { jsx as t } from "react/jsx-runtime";
import { StyledPlacehoder as c } from "./styles110.mjs";
import { Children as p, isValidElement as f } from "react";
const y = (a) => {
  const { selected: r, options: o, placeholder: d, children: i } = a, n = Array.isArray(r);
  if (r === "" || r === void 0 || n && r.length === 0)
    return /* @__PURE__ */ t(c, { children: d });
  const s = n ? o?.filter((e) => r.some((l) => l === e.value)).map((e) => e.label).join(", ") : o?.find((e) => e.value === r)?.label;
  if (i) {
    const e = p.toArray(i).find(
      (l) => f(l) && l.props.value === r
    );
    if (e)
      return e;
  }
  return /* @__PURE__ */ t("span", { children: s });
};
export {
  y as Value
};
//# sourceMappingURL=index178.mjs.map
